import { Card, Col, Button } from 'antd';
import styled from 'styled-components'

export const StyledCard = styled(Card)`
    width: 320px;
    background-color: white;
    display: flex;
    flex-direction: column;
    box-shadow: 3px 0px 20px rgba(0, 0, 0, 0.10);
    border: none;

    & .ant-card-body {
        height: 100%;
        display: flex;
        flex-direction: column;
    }
`;

export const Title = styled.h2`
    color: #7bad7e;
`

export const StyledCardFooter = styled.div`
    margin-top: auto;
    padding-top: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
`

export const StyledButtonGroup = styled.div`
    width: 100%;
    display: flex;
    gap: 12px;
    justify-content: center;
`

export const StyledCol = styled(Col)`
    & > div {
        display:  flex;
        flex-direction:  column;

        strong {
            color: #424647;
            font-weight: 400;
        }
      
        span {
            color: #171c2f;
            font-weight: 700;
            font-size: .8rem;
        }
    }
`
const circleButtonBase = `
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
`

export const DeleteButton = styled(Button)`
    ${circleButtonBase}
    background-color: #ff4d4f;
    color: #fff;

    &:hover {
        backgroundColor: #fff;
        border-color: #ff4d4f;
        color: #ff4d4f;
    }
`
export const EditButton = styled(Button)`
    ${circleButtonBase}
    background-color: #7BAD7E;
    color: #fff;

    &:hover {
        backgroundColor: #fff;
        border-color: #7BAD7E;
        color: #7BAD7E;
    }
`

export const DuplicateButton = styled(Button)`
    ${circleButtonBase}
    background-color: #4a90d9;
    color: #fff;

    &:hover {
        backgroundColor: #fff;
        border-color: #4a90d9;
        color: #4a90d9;
    }
`

export const StyledTag = styled.span`
    display: inline-block;
    background-color: #7BAD7E;
    border-radius: 15px;
    padding: 2px 10px;
    color: #fff !important;
    margin: 3px;
`

export const SubtypeBadge = styled.span`
    display: block;
    font-size: .7rem;
    font-weight: 400;
    text-transform: capitalize;
    margin-top: 6px;
    color: ${({ subtype }) => subtype === 'supply' ? '#8ab8e8' : '#a0b8a2'};
`